<template>
  <button class="dropdown-btn dropdown-single" @click="showHide">
    {{ dropdownTitle }}
    <i title="לא נצפה" class="mdi mdi-menu-down"></i>
    <transition name="fade"
      ><div class="close-options" v-if="show">
        <button>סגור</button>
      </div></transition
    >
    <transition name="options-fade">
      <div class="dropdown-options-container" v-if="show">
        <div class="dropdown-options">
          <div class="top1"><img src="@/assets/images/top1.png" alt="" /></div>
          <span
            :class="optionCls(item.id)"
            v-for="item in item.includes"
            :key="item.id"
            @click="toggleOption(item)"
            >{{ item.label }}</span
          >
        </div>
      </div>
    </transition>
  </button>
</template>

<script>
export default {
  props: {
    item: Object,
    show: Boolean,
  },
  data() {
    return {
      // show: false,
      active: [],
    };
  },
  methods: {
    showHide(e) {
      if (
        e.target.classList[0] === "dropdown-btn" ||
        e.target.classList[0] === "mdi"
      ) {
        if (!this.show) {
          this.$emit("show-options");
        } else {
          this.$emit("close-options");
        }
      }
    },
    toggleOption(option) {
      if (this.isActive(option.id)) {
        this.active = [];
      } else {
        this.active = [option];
      }
      this.$emit("option-selected", this.active);
      this.$emit("close-options");
    },
    isActive(id) {
      const list = this.active.filter(item => {
        return item.id === id;
      });
      if (list.length > 0) {
        return true;
      }
      return false;
    },
    optionCls(id) {
      if (this.isActive(id)) {
        return "dropdown-option active";
      }
      return "dropdown-option";
    },
  },
  computed: {
    dropdownTitle() {
      if (this.active.length === 0) {
        return this.item.title;
      }
      return `${this.active[0].label}`;
    },
  },
  watch: {
    item() {
      if (this.active.length === 0 && this.item.selected.length > 0) {
        this.item.selected.forEach(value => {
          this.active.push(value);
        });
      }
    },
  },
  mounted() {
    if (this.active.length === 0 && this.item.selected.length > 0) {
      this.item.selected.forEach(value => {
        this.active.push(value);
      });
    }
  },
};
</script>

<style lang="scss">
.dropdown-single {
  .dropdown-option {
    width: 100%;
  }
  .dropdown-options {
    .columns {
      justify-items: center;
      align-items: center;
      .options-info {
        padding: 1rem;
        text-align: center;
        background-color: #c6aa51;
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .dropdown-single {
    .dropdown-options {
      width: 100%;
    }
  }
}
</style>

  